var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgIcCopied = function SvgIcCopied(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "m382-354 339-339q12-12 28.5-12t28.5 12 12 28.5-12 28.5L410-268q-12 12-28 12t-28-12L182-440q-12-12-11.5-28.5T183-497t28.5-12 28.5 12z"
  })));
};
export default SvgIcCopied;